import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IhmLinkComponent } from './ihm-link.component';

@NgModule({
  imports: [CommonModule, RouterModule, MatTooltipModule],
  declarations: [IhmLinkComponent],
  exports: [IhmLinkComponent]
})
export class IhmLinkModule {}
